/*
*  Расписание врача (постраничная навигация по дням)
*  <div class="database__main" id="my-schedule" data-controller="my-schedule"></div>
*
*  Контроллер — "клей": жизненный цикл, состояние (текущий день) и stimulus-actions.
*  Вся логика вынесена в services/schedule/*
*/
import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import 'select2/dist/js/select2.min'
import 'select2/dist/css/select2.min.css'
import 'jquery-datetimepicker'   // нужен appointmentModal ($.datetimepicker)
import 'jquery-mask-plugin'      // нужен appointmentModal ($.fn.mask)
import '../../css/my-schedule-nav.css'
import '../../css/date-range.css'

import { openAppointmentModal } from '../modules/appointmentModal';
import { fetchStaffs } from "../services/staff";

import { registerScheduleTemplates } from '../services/schedule/scheduleTemplates';
import { fetchDay } from '../services/schedule/scheduleApi';
import { fetchRange } from '../services/schedule/scheduleApi';
import { renderDay, clearSchedule, renderError, groupRowsByDay } from '../services/schedule/scheduleRenderer';
import {
    renderNavigator,
    setLoading,
    setMoreLoading,
    setEndReached,
    scrollToDayBlock
} from '../services/schedule/scheduleNavigator';
import { connectScheduleSocket } from '../services/schedule/scheduleRealtime';
import {bindScheduleUi, flashAlert, initUiActions} from '../services/schedule/scheduleUi';
import { appendComment } from '../services/schedule/scheduleNotes';
import {dateKey, addDays, clampKey, getAllowedRange, isDate} from '../services/schedule/dateUtils';
import {getFromInput, getToInput, initDataPicker, setDateRange} from '../services/schedule/scheduleDataRange';



export default class extends Controller {
    minClientAge = '';
    ctx = null;           // { staffId, doctorInfo, staffs, salons, patients }
    requestSeq = 0;       // защита от гонок при быстром листании
    pending = new Set();  // запросы в полёте (чтобы их можно было отменить)
    loadedDays = [];      // ключи уже отрисованных дней (по порядку)
    loadingMore = false;  // идёт догрузка следующего дня
    observer = null;
    socket = null;
    unbindUi = null;

    dateFrom = null;
    dateTo = null;


    initialize() {
        super.initialize();
        registerScheduleTemplates();
    }

    async connect() {
        if (sessionStorage.getItem('token') === null) this.logout();

        $('#my-schedule').html(Twig.twig({ ref: "my-schedule" }).render({}));
        initUiActions()
        initDataPicker(this);

        this.unbindUi = bindScheduleUi();
        this.setupInfiniteScroll();
        await this.loadContext();

        let dateFrom = addDays(dateKey(new Date()), -2)
        let dateTo = addDays(dateFrom,+9)
        await this.showRage(dateFrom,dateTo);

        try {
            this.socket = await connectScheduleSocket(() => this.reload());
        } catch (err) {
            console.log(err);
        }
    }

    disconnect() {
        this.abortPending();
        this.observer?.disconnect();
        this.unbindUi?.();
        this.socket?.close();
    }

    logout() {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        $('#authorization').html(Twig.twig({ ref: "authorization" }).render({}));
    }

    /* ---------- данные ---------- */

    // справочники — один раз за подключение
    async loadContext() {
        const staffId = global.WhoIs.StaffID;
        const staffsRes = await fetchStaffs({ status: 'all' });
        const staffs = {};
        staffsRes.data.forEach((item) => { staffs[item.staff_id] = item; });

        this.ctx = {
            staffId,
            staffs,
            salons: api.salonsList(),
            doctorInfo: api.doctorList('doctor').find((d) => d.StaffID === staffId),
            patients: new Map(),
        };
    }


    actionONFromInput() {
        const from = getFromInput().val();
        const to = getToInput().val();
        // если "по" стало раньше "с" — сбрасываем его, иначе оставляем
        if (isDate(from) && to && to < from) getToInput().val('');
        this.updateFilterButtons();
    }

    actionONTOInput() {
        this.updateFilterButtons();
    }

    updateFilterButtons() {
        const from = getFromInput().val();
        const to = getToInput().val();
        const fromOk = isDate(from);
        const toOk = fromOk && isDate(to) && to >= from;

        $('#myScheduleWeekBtn').toggleClass('d-none', !(fromOk && !to));
        $('#myScheduleApplyBtn').toggleClass('d-none', !toOk);

        // подсветка ошибки
        getFromInput().toggleClass('is-invalid', !fromOk)
            .siblings('.myScheduleToolbar__hint').text(!fromOk ? 'Дата "с" не может быть пустой' : '');


        getToInput().toggleClass('is-invalid', Boolean(to) && !toOk)
            .siblings('.myScheduleToolbar__hint').text(Boolean(to) && !toOk ? 'Дата "по" не может быть раньше даты "с"' : '');
        ;
    }

    actionPlusWeek() {
        const from = getFromInput().val();
        if (!isDate(from)) return;
        getToInput().val(addDays(from, 6));   // 6 = всего 7 дней включительно; нужно +7 — поставьте 7
        this.actionApplyRange();
    }
    actionCloseNote(event)       {
        $(`#check-${event.params.id}`).prop('checked', false);
    }
    actionSubWeek(){
        let from = addDays(this.dateFrom,-7);

        this.showRage(from,addDays(from,7))
    }
    actionNextWeek(){
        let from = addDays(this.dateFrom,7);

        this.showRage(from,addDays(from,7))
    }

    actionApplyRange() {
        const from = getFromInput().val();
        const to = getToInput().val();
        if (!isDate(from) || !isDate(to) || to < from) return;

        $('#myScheduleWeekBtn, #myScheduleApplyBtn').addClass('d-none');
        
        this.showRage(from, to);
    }
    actionSubmitFilter() {
        const to = getToInput().val();
        if (to) this.actionApplyRange();
        else this.actionPlusWeek();
    }

    today() {
        const today = new Date();
        const pad = (x) => String(x).padStart(2, '0');
        const from = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
        getFromInput().val(from);
        getToInput().val(addDays(from, 6));
        this.actionApplyRange();
    }


    /* ---------- загрузка дней ---------- */

    async fetchRows(from, to) {
        let xhr = null;
        if (to){
            xhr = fetchRange(this.ctx.staffId, from, to);
        }else{
            xhr = fetchDay(this.ctx.staffId, from);
        }


        this.pending.add(xhr);

        try {
            const json = await xhr;
            return json.data;
        } finally {
            this.pending.delete(xhr);
        }
    }

    abortPending() {
        this.pending.forEach((x) => x.abort());
        this.pending.clear();
    }

    showRage(from, to = from,keepScroll) {
        this.dateFrom = from;
        this.dateTo = to;

        setDateRange(from, to);
        setEndReached(false);

        return this.loadRange(from,to,keepScroll);
    }
    loadRange(from,to,keepScroll) {
        return this.loadKeys(
            this.getDatesBetween(from, to),
            keepScroll
        )
    }

    getDatesBetween(start, end) {
        const dates = []

        for (
            let date = new Date(start);
            date <= new Date(end);
            date.setDate(date.getDate() + 1)
        ) {
            dates.push(date.toISOString().slice(0, 10))
        }

        return dates
    }

    // перезагрузка всех уже показанных дней (позиция прокрутки сохраняется)
    reload() {
        const keys = this.loadedDays.length ? [...this.loadedDays] : [];
        return this.showRage(this.dateFrom,this.dateTo, true);
    }

    // полная (пере)отрисовка списка из заданных дней
    async loadKeys(keys, keepScroll) {
        const seq = ++this.requestSeq;
        this.abortPending();
        this.loadingMore = false;
        setMoreLoading(false);
        this.loadedDays = [];
        setLoading(true);

        const scrollY = window.scrollY;

        try {
            const allRows = await this.fetchRows(keys[0], keys[keys.length - 1]);

            if (seq !== this.requestSeq) return;

            this.ctx.patients = new Map();
            clearSchedule();

            const rowsByDay = groupRowsByDay(allRows);

            keys.forEach((key) => {
                renderDay(rowsByDay[key] || [], this.ctx, key);
            });

            this.loadedDays = keys;
            renderNavigator(this.loadedDays);
            window.scrollTo(0, keepScroll ? scrollY : 0);
        } catch (err) {
            if (seq !== this.requestSeq || err?.statusText === 'abort') return;

            console.error(err);
            renderError();
            return;
        } finally {
            if (seq === this.requestSeq) {
                setLoading(false);
            }
        }

        this.maybeLoadMore();
    }


    /* ---------- бесконечная прокрутка вниз ---------- */

    setupInfiniteScroll() {
        return;
        this.sentinel = document.getElementById('myScheduleSentinel');
        if (!this.sentinel) return;
        this.observer = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) this.loadNextDay();
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this.sentinel);
    }

    // низ списка рядом с экраном (запас 300px)?
    isNearBottom() {
        return this.sentinel && this.sentinel.getBoundingClientRect().top <= window.innerHeight + 300;
    }

    // если день короткий и маркер всё ещё виден — догружаем дальше
    maybeLoadMore() {
        if (this.isNearBottom()) this.loadNextDay();
    }

    async loadNextDay() {
        if (this.loadingMore || this.loadedDays.length === 0) return;

        const next = addDays(this.loadedDays[this.loadedDays.length - 1], 1);
        if (next > getAllowedRange().max) {
            setEndReached(true);
            return;
        }

        const seq = this.requestSeq;
        this.loadingMore = true;
        setMoreLoading(true);
        let ok = false;

        try {
            const rows = await this.fetchRows(next);
            if (seq !== this.requestSeq) return;
            renderDay(rows, this.ctx, next);
            this.loadedDays.push(next);
            renderNavigator(this.loadedDays);
            ok = true;
        } catch (err) {
            if (seq === this.requestSeq && err?.statusText !== 'abort') console.error(err);
        } finally {
            if (seq === this.requestSeq) {
                this.loadingMore = false;
                setMoreLoading(false);
            }
        }
        if (ok && seq === this.requestSeq) this.maybeLoadMore();
    }

    // appointmentModal ожидает this.tableSchedule.draw()
    get tableSchedule() {
        return { draw: () => this.reload() };
    }

    scrollToDay(event) {
        scrollToDayBlock(event.params.day);
    }


    /* ---------- действия над записями ---------- */

    openAppointmentModal(event) {
        openAppointmentModal.call(this, event, 'doctor');
    }

    cancelOrder(event) {
        const id = event.params.id;
        const data = $($('#canselOrderForm-' + id)[0]).serializeObject();
        if (data.canselReason === '') {
            flashAlert($('#canselOrderForm-' + id + ' .canselOrder__title'), 'append', 'blockTimeAlert-' + id,
                'color: red; display: inline-block; padding-left: 10px');
            return;
        }
        const result = api.cancelOrder(data.orderId, data.canselReason);
        $('#check-' + id).prop('checked', false);
        if (result && result.Status === 200) this.reload();
    }

    blockTime(event) {
        const id = event.params.id;
        const data = $($('#blockTime-' + id)[0]).serializeObject();
        if (data.reason === '') {
            flashAlert($('#blockTime-' + id + ' label'), 'append', 'blockTimeAlert-' + id,
                'color: red; display: inline-block; padding-left: 10px');
            return;
        }
        const result = api.blockTime(data);
        if (result && result.Status === 200) this.reload();
    }

    isApproved(event) {
        const result = api.isApproved(event.params.dataid);
        if (!result || result.Status !== 200) return;

        const row = event.params.row;
        const approved = result.object[0] === 'true';
        $('#myScheduleStringId-' + row)
            .toggleClass('myScheduleString-isApproved', approved)
            .toggleClass('myScheduleString-noApproved', !approved);
        $('#isApproved-' + row + ' + label').text(approved ? 'да' : 'нет');
        $('#isApproved-' + row).attr('checked', approved).val(approved);
    }

    changeOrderServiceList(event) {
        const diagnostic = $('#orderServiceList-' + event.params.id).val();
        api.changeOrderServiceList(event.params.orderid, diagnostic);
    }

    addComment(event) {
        const id = event.params.id;
        const data = $($('#addCommentForm-' + id)[0]).serializeObject();
        const text = data.addComment.replace(/[^a-zа-яё0-9\s]/gi, '');
        if (text === '') {
            flashAlert($('#addCommentForm-' + id + ' label'), 'after', 'addCommentAlert-' + id);
            return;
        }

        const old = api.searchOrderDoctor(data.orderId);
        if (!old || old.Status !== 200) return;

        const notes = appendComment(
            JSON.parse(old.object[0]).Notes,
            text,
            new Date().toLocaleDateString('ru-KZ')
        );
        const result = api.addAdditionalComment(data.orderId, notes);
        if (result && result.Status === 200) {
            $('#checkComment-' + id).prop('checked', false);
            this.reload();
        }
    }


    closeAddComment(event) { $('#checkComment-' + event.params.id).prop('checked', false); }
}
